import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Select } from '@cbhq/cds-web/alpha/select';

import { useOrganization } from '../../../contexts/OrganizationContext';

type LegalEntityDropdownProps = {
  value: string[];
  onChange: (value: string | string[] | null) => void;
  variant?: 'negative' | undefined;
  helperText?: string | null;
  testID?: string;
  disabled?: boolean;
};

const messages = defineMessages({
  label: {
    id: 'Team.Member.legalEntitySelectorLabel',
    defaultMessage: 'Legal entities',
    description: 'Label for the legal entity selector',
  },
  placeholder: {
    id: 'Team.Member.legalEntitySelectorPlaceholder',
    defaultMessage: 'Select entities',
    description: 'Placeholder for the legal entity selector',
  },
});

export function LegalEntityDropdown({
  value,
  onChange,
  variant,
  helperText,
  testID = 'team-member-entity-select',
  disabled,
}: LegalEntityDropdownProps) {
  const { formatMessage } = useIntl();
  const { selectedOrganization } = useOrganization();
  const label = formatMessage(messages.label);

  const legalEntityOptions = useMemo(
    () =>
      (selectedOrganization?.legalEntities ?? []).map((le) => ({
        value: le.legalEntityId,
        label: le.legalEntityName,
      })),
    [selectedOrganization?.legalEntities],
  );

  return (
    <Select
      type="multi"
      value={value}
      onChange={onChange}
      options={legalEntityOptions}
      label={label}
      placeholder={formatMessage(messages.placeholder)}
      accessibilityLabel={label}
      variant={variant}
      helperText={helperText}
      testID={testID}
      disabled={disabled}
    />
  );
}
